module.exports = __webpack_public_path__ + "static/core-33d183c3030337de0c86912bc0d2b39f.jpg";